import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { JobBlanketOrderRemaining } from '@app/cp/shared/models/JobBlanketOrderRemaining';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';

@Component({
    selector: 'blanket-pos',
    templateUrl: './blanket-pos.component.html',
    styleUrls: ['./blanket-pos.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BlanketPOsComponent extends BaseGridUIComponent<JobBlanketOrderRemaining, null, ConstructionService>  {
    constructor(svc_data: ConstructionService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
    }
    getData() {
        this.clear(false);
        if (!this._id) {
            return;
        }
        this.svc_data.getJobBlanketOrderRemaining(this._id).subscribe((info: BaseMessageInfo) => {
            this.gridData = info.primaryReturn;
        });
    }
}
